import "./bootstrap";

import App from "@/App.vue";
import {createApp, ref} from "vue";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import VueApexCharts from "vue3-apexcharts";
import VueNumber from "vue-number-animation";

import i18n from "@/lang";
import store from "@/store";
import router from "@/router";
import MainPlugin from "@/plugins";
import Directives from "./directives";

const app = createApp(App);

window.fetchNotification = ref(false);
app.use(i18n);
app.use(store);
app.use(router);
app.use(MainPlugin);
app.use(Directives);

app.use(VueApexCharts);
app.use(ElementPlus);
app.use(VueNumber);

app.mount("#app");
